import { ReactComponent as LocationIcon } from "../../../Assets/Icons/newLocation.svg";
import image from "../../../Assets/Icons/Image.svg";

export default function RedeemedOffers({ offerDetails }) {
  console.log("offerDetails", offerDetails);
  return (
    <div
      style={{ scrollbarWidth: "none" }}
      className="max-h-[600px] overflow-y-auto w-full flex flex-col gap-4 font-poppins bg-white p-6 rounded-lg"
    >
      <div className="w-full flex justify-start items-center gap-4">
        <img
          src={
            offerDetails?.merchant?.logo
              ? process.env.REACT_APP_S3_URL + offerDetails?.merchant?.logo
              : image
          }
          className="w-[80px] h-[80px] border border-[#0000001A] rounded-full"
        />
        <div className="flex flex-col justify-start items-start">
          <p className="text-[24px] font-[600] text-[#000000]">
            {offerDetails?.merchant?.businessName}
          </p>
          <div className="flex items-center gap-2">
            <LocationIcon />
            <p className="text-[14px] font-[400] text-[#767676]">
              {offerDetails?.merchant?.address}
            </p>
          </div>
        </div>
      </div>
      <h2 className="text-[20px] font-[600] text-[#000000] text-start">
        Offers Redeemed 
      </h2>
      <div className="w-full flex flex-col gap-4">
        {offerDetails?.offers?.length > 0 ? (
          offerDetails?.offers?.map((offer, index) => (
            <div key={index} className="flex items-center justify-between p-3">
              <div className="flex items-center gap-3">
                <img
                  src={
                    offer?.thumbnailImage
                      ? process.env.REACT_APP_S3_URL + offer?.thumbnailImage
                      : image
                  }
                  className="w-[80px] h-[60px] rounded-[4px]"
                />
                <div className="flex flex-col justify-start items-start">
                  <p className="text-[16px] font-[600] text-[#000000]">
                    {offer?.title}
                  </p>
                </div>
              </div>
              <div className="bg-[#E6F8FF] p-2 border-2 border-[#00ADEF] rounded-[4px]">
                <h4 className="text-[#00ADEF] font-[500] text-[12px] font-poppins">
                  {offer?.offerType === "INSTORE_SWOODLE_OFFER"
                    ? "INSTORE SWOODLE OFFER"
                    : "ONLINE OFFER"}
                </h4>
              </div>
            </div>
          ))
        ) : (
          <p className="text-[16px] font-[400] text-[#767676]">
            No redeemed offers available.
          </p>
        )}
      </div>
    </div>
  );
}
